import { type ReactNode } from 'react';
import { useIntl } from 'react-intl';

import { ViewIcon } from '@dynatrace/strato-icons';

import { ChartTooltip } from '../../../../core/components/overlay-tooltip/OverlayTooltip.js';
import { FLAME_TOOLTIP_MESSAGES } from './messages.js';

interface IsolateSegmentActionProps {
  onSelect: () => void;
  /**
   * When `true`, the action is shown but visually disabled. Used when the
   * hovered span is already the current isolation root.
   */
  disabled?: boolean;
}

/**
 * Footer action for the flame tooltip that isolates the hovered span. Extracted
 * so `FlameChart` and `FlameGraph` can plug the same "isolate" affordance into
 * their `globalActions` callback without duplicating the icon or intl string.
 * @internal
 */
export function IsolateSegmentAction({
  onSelect,
  disabled,
}: Readonly<IsolateSegmentActionProps>): ReactNode {
  const intl = useIntl();
  return (
    <ChartTooltip.Action
      label={intl.formatMessage(FLAME_TOOLTIP_MESSAGES.isolateSegment)}
      icon={<ViewIcon />}
      onSelect={onSelect}
      disabled={disabled}
    />
  );
}
